module.exports = __webpack_public_path__ + "static/media/badge4.e2a96ead.svg";